export default __webpack_public_path__ + "static/media/sz.401a7fb4.svg";